import PropTypes from 'prop-types';
import styled from 'styled-components';

export const FlexBox = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  display: flex;
  flex-direction: ${props => props.direction};
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  flex-wrap: ${props => props.wrap};
`;

FlexBox.propTypes = {
  alignItems: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  justifyContent: PropTypes.string,
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse'])
};

FlexBox.defaultProps = {
  alignItems: 'center',
  direction: 'row',
  justifyContent: 'normal',
  wrap: 'nowrap'
};

export const FlexItem = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  flex-grow: ${props => props.grow};
  flex-shrink: ${props => props.shrink};
  flex-basis: ${props => props.basis};
  align-self: ${props => props.alignSelf};
  order: ${props => props.order};
`;

FlexItem.propTypes = {
  alignSelf: PropTypes.string,
  basis: PropTypes.string,
  grow: PropTypes.number,
  shrink: PropTypes.number,
  order: PropTypes.number,
  qa: PropTypes.string
};

FlexItem.defaultProps = {
  alignSelf: 'auto',
  basis: 'auto',
  grow: 0,
  shrink: 0,
  order: 0,
  qa: undefined
};
